module.exports = __webpack_public_path__ + "img/www.indeed.com.581c1916.png";